import {
  Button,
  Divider,
  Space,
  Table,
  TableProps,
  Card,
  Row,
  Col,
  Input,
  Tag,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_API_URL } from "../../../utils/consts";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { isAdmin, isSuperAdmin } from "../../../utils/permissions";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import WorkSectorModal from "../../../Components/Modals/WorkSectorModal/WorkSectorModal";
import { format } from "date-fns";
import { Modal } from "antd";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import PositionInSector from "../../../Components/Modals/PositionInSector/PositionInSector";
import { isLocationActive } from "../../../utils/helpers/locationVisibility";
import "./WorkSectors.scss";
const { Text } = Typography;
const { confirm } = Modal;

type Props = {};

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
  id: string;
}

const WorkSectors: React.FC<Props> = () => {
  const params = useParams();
  const { t } = useTranslation();
  const authUser: any = useAuth();
  const userData = useSelector((state: any) => state.userData.user);
  const [workSectors, setWorkSectors] = useState<any>(undefined);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [workSectorData, setWorkSectorData] = useState<any>(undefined);
  const [positionInSectorData, setPositionInSectorData] =
    useState<any>(undefined);
  const [positionInSector, setPositionInSector] = useState<any>(undefined);
  const [locations, setLocations] = useState<any>(undefined);
  const [viewModeSectors, setViewModeSectors] = useState<"cards" | "table">(
    "cards"
  );
  const [viewModePositions, setViewModePositions] = useState<"cards" | "table">(
    "cards"
  );
  const [sectorFilter, setSectorFilter] = useState("");
  const [positionFilter, setPositionFilter] = useState("");

  const [isPositionInSectorModalOpen, setPositionInSectorModalOpen] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedMonth, setSelectedMonth] = useState<any>(dayjs(new Date()));

  useEffect(() => {
    axios

      .get(`${BASE_API_URL}/${userData?.clientId}/locations`)
      .then((res) => {
        setLocations((res.data || []).filter(isLocationActive));
      })
      .catch((err) => console.error(err));
  }, []);

  const filteredSectors =
    workSectors?.filter((ws: any) =>
      ws.name.toLowerCase().includes(sectorFilter.trim().toLowerCase())
    ) || [];

  const filteredPositions =
    positionInSector?.filter((p: any) =>
      p.name.toLowerCase().includes(positionFilter.trim().toLowerCase())
    ) || [];

  const SectorColumns: TableProps<any>["columns"] = [
    {
      title: t("Sector Name"),
      dataIndex: "name",
      key: "name",
      render: (value) => {
        return <b>{value}</b>;
      },
    },
    {
      title: t("Location"),
      dataIndex: "location",
      key: "location",
      render: (location) => {
        return <span>{location?.name || t("No location")}</span>;
      },
    },
    {
      title: t("Color"),
      dataIndex: "color",
      key: "color",
      render: (color) => (
        <div
          style={{
            width: 25,
            height: 25,
            backgroundColor: color || "#fff",
            borderRadius: 4,
            border: "1px solid #999",
          }}
          title={color}
        />
      ),
    },
    {
      title: t("Action"),
      key: "action",
      render: (row, record) => (
        <Space size="middle">
          <Button
            className="ws-btn"
            onClick={() => {
              //   navigate(`/settings/dailyRevenue/${row._id}`);
              setWorkSectorData(row);
              setModalOpen(true);
            }}
          >
            {t("View")}
          </Button>
          <Button
            danger
            className="ws-btn"
            onClick={() => {
              confirm({
                title: t("Are you sure you want to delete this revenue?"),
                content: t("This action cannot be undone."),
                okText: t("Yes, Delete"),
                okType: "danger",
                cancelText: t("Cancel"),
                onOk() {
                  return axios
                    .delete(
                      `${BASE_API_URL}/admin/${userData?.clientId}/deleteWorkSector/${row._id}`
                    )
                    .then(() => {
                      return axios
                        .get(
                          `${BASE_API_URL}/admin/${userData.clientId}/getWorkSectors`
                        )
                        .then((res) => {
                          setWorkSectors(res.data);
                        });
                    })
                    .catch((error) => console.error(error));
                },
              });
            }}
          >
            {t("Delete")}
          </Button>
        </Space>
      ),
    },
  ];

  const positionInSectorColumns: TableProps<any>["columns"] = [
    {
      title: t("Position name"),
      dataIndex: "name",
      key: "name",
      //   render: (value) => {
      //     return <b>{format(new Date(value), "d-MMM-yy")}</b>;
      //   },
    },

    {
      title: t("Work Sector"),
      dataIndex: "workSector",
      key: "workSector",
      render: (value) => {
        return (
          <b>
            {value.name} :: {value?.location?.name}
          </b>
        );
      },
    },

    {
      title: t("Action"),
      key: "action",
      render: (row, record) => (
        <Space size="middle">
          <Button
            className="ws-btn"
            onClick={() => {
              //   navigate(`/settings/dailyRevenue/${row._id}`);
              setPositionInSectorData(row);
              setPositionInSectorModalOpen(true);
            }}
          >
            {t("View")}
          </Button>
          <Button
            danger
            className="ws-btn"
            onClick={() => {
              confirm({
                title: t("Are you sure you want to delete this revenue?"),
                content: t("This action cannot be undone."),
                okText: t("Yes, Delete"),
                okType: "danger",
                cancelText: t("Cancel"),
                onOk() {
                  return axios
                    .delete(
                      `${BASE_API_URL}/admin/${userData?.clientId}/deletePosition/${row._id}`
                    )
                    .then(() => {
                      return axios
                        .get(
                          `${BASE_API_URL}/admin/${userData.clientId}/getPositions`
                        )
                        .then((res) => {
                          setPositionInSector(res.data);
                        });
                    })
                    .catch((error) => console.error(error));
                },
              });
            }}
          >
            {t("Delete")}
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (params.id !== "new" && userData.clientId) {
      axios
        .get(`${BASE_API_URL}/admin/${userData.clientId}/getWorkSectors`)
        .then((res) => {
          setWorkSectors(res.data);
        })
        .catch((error) => console.error(error));
      axios
        .get(`${BASE_API_URL}/admin/${userData.clientId}/getPositions`)
        .then((res) => {
          setPositionInSector(res.data);
        })
        .catch((error) => console.error(error));
    }
  }, [params.id]);

  const onChange = (key: string) => {
    console.log(key);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("Work Sector"),
      children: (
        <>
          <Card className="ws-hero">
            <div className="ws-hero__content">
              <div>
                <Typography.Title level={5} style={{ margin: 0 }}>
                  {t("Work Sector")}
                </Typography.Title>
                <Typography.Text type="secondary">
                  Organizujte sektore i lokacije.
                </Typography.Text>
              </div>
              <div className="ws-hero__actions">
                <Button
                  size="small"
                  className={`ws-btn ${
                    viewModeSectors === "cards" ? "ws-btn--active" : ""
                  }`}
                  onClick={() => setViewModeSectors("cards")}
                >
                  Grid
                </Button>
                <Button
                  size="small"
                  className={`ws-btn ${
                    viewModeSectors === "table" ? "ws-btn--active" : ""
                  }`}
                  onClick={() => setViewModeSectors("table")}
                >
                  Tabela
                </Button>
                <Input
                  allowClear
                  placeholder={t("Filter")}
                  value={sectorFilter}
                  onChange={(e) => setSectorFilter(e.target.value)}
                  style={{ width: 180 }}
                />
                {(isAdmin(authUser.roles) || isSuperAdmin(authUser.roles)) && (
                  <Button
                    type="primary"
                    className="ws-btn ws-btn--primary"
                    onClick={() => {
                      setModalOpen(true);
                    }}
                  >
                    {t("Add Work Sector")}
                  </Button>
                )}
              </div>
            </div>
          </Card>

          {viewModeSectors === "cards" && (
            <Row gutter={[16, 16]} className="ws-grid">
              {filteredSectors.length === 0 && (
                <Col span={24}>
                  <Card className="ws-card" bordered={false}>
                    <Typography.Text type="secondary">
                      {t("No data")}
                    </Typography.Text>
                  </Card>
                </Col>
              )}
              {filteredSectors.map((ws: any) => (
                <Col xs={24} md={12} lg={8} key={ws._id}>
                  <Card className="ws-card" bordered={false}>
                    <div className="ws-card__header">
                      <div>
                        <Typography.Text strong style={{ fontSize: 16 }}>
                          {ws.name}
                        </Typography.Text>
                        <div className="ws-card__meta">
                          {ws.location?.name || t("No location")}
                        </div>
                      </div>
                      <div
                        className="ws-color"
                        style={{ background: ws.color || "#fff" }}
                        title={ws.color}
                      />
                    </div>
                    <div className="ws-card__actions">
                      <Button
                        size="small"
                        type="text"
                        className="ws-btn"
                        onClick={() => {
                          setWorkSectorData(ws);
                          setModalOpen(true);
                        }}
                      >
                        {t("View")}
                      </Button>
                      <Button
                        danger
                        size="small"
                        type="text"
                        className="ws-btn"
                        onClick={() => {
                          confirm({
                            title: t(
                              "Are you sure you want to delete this revenue?"
                            ),
                            content: t("This action cannot be undone."),
                            okText: t("Yes, Delete"),
                            okType: "danger",
                            cancelText: t("Cancel"),
                            onOk() {
                              return axios
                                .delete(
                                  `${BASE_API_URL}/admin/${userData?.clientId}/deleteWorkSector/${ws._id}`
                                )
                                .then(() =>
                                  axios
                                    .get(
                                      `${BASE_API_URL}/admin/${userData.clientId}/getWorkSectors`
                                    )
                                    .then((res) => setWorkSectors(res.data))
                                )
                                .catch((error) => console.error(error));
                            },
                          });
                        }}
                      >
                        {t("Delete")}
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          )}

          {viewModeSectors === "table" && (
            <Card className="ws-card" bordered={false}>
              <Table
                columns={SectorColumns}
                dataSource={filteredSectors}
                pagination={false}
                rowKey="_id"
                className="ws-table"
              />
            </Card>
          )}
        </>
      ),
    },
    {
      key: "2",
      label: t("Position in sector"),
      children: (
        <>
          <Card className="ws-hero">
            <div className="ws-hero__content">
              <div>
                <Typography.Title level={5} style={{ margin: 0 }}>
                  {t("Position in sector")}
                </Typography.Title>
                <Typography.Text type="secondary">
                  Upravljajte ulogama i sektorima.
                </Typography.Text>
              </div>
              <div className="ws-hero__actions">
                <Button
                  size="small"
                  className={`ws-btn ${
                    viewModePositions === "cards" ? "ws-btn--active" : ""
                  }`}
                  onClick={() => setViewModePositions("cards")}
                >
                  Grid
                </Button>
                <Button
                  size="small"
                  className={`ws-btn ${
                    viewModePositions === "table" ? "ws-btn--active" : ""
                  }`}
                  onClick={() => setViewModePositions("table")}
                >
                  Tabela
                </Button>
                <Input
                  allowClear
                  placeholder={t("Filter")}
                  value={positionFilter}
                  onChange={(e) => setPositionFilter(e.target.value)}
                  style={{ width: 180 }}
                />
                {(isAdmin(authUser.roles) || isSuperAdmin(authUser.roles)) && (
                  <Button
                    type="primary"
                    className="ws-btn ws-btn--primary"
                    onClick={() => {
                      setPositionInSectorModalOpen(true);
                    }}
                  >
                    {t("Add position in sector")}
                  </Button>
                )}
              </div>
            </div>
          </Card>

          {viewModePositions === "cards" && (
            <Row gutter={[16, 16]} className="ws-grid">
              {filteredPositions.length === 0 && (
                <Col span={24}>
                  <Card className="ws-card" bordered={false}>
                    <Typography.Text type="secondary">
                      {t("No data")}
                    </Typography.Text>
                  </Card>
                </Col>
              )}
              {filteredPositions.map((p: any) => (
                <Col xs={24} md={12} lg={8} key={p._id}>
                  <Card className="ws-card" bordered={false}>
                    <div className="ws-card__header">
                      <div>
                        <Typography.Text strong style={{ fontSize: 16 }}>
                          {p.name}
                        </Typography.Text>
                        <div className="ws-card__meta">
                          {p.workSector?.name} · {p.workSector?.location?.name}
                        </div>
                      </div>
                      <Tag className="ws-tag" color="#349cebff">
                        {t("Position")}
                      </Tag>
                    </div>
                    <div className="ws-card__actions">
                      <Button
                        size="small"
                        type="text"
                        className="ws-btn"
                        onClick={() => {
                          setPositionInSectorData(p);
                          setPositionInSectorModalOpen(true);
                        }}
                      >
                        {t("View")}
                      </Button>
                      <Button
                        danger
                        size="small"
                        type="text"
                        className="ws-btn"
                        onClick={() => {
                          confirm({
                            title: t(
                              "Are you sure you want to delete this revenue?"
                            ),
                            content: t("This action cannot be undone."),
                            okText: t("Yes, Delete"),
                            okType: "danger",
                            cancelText: t("Cancel"),
                            onOk() {
                              return axios
                                .delete(
                                  `${BASE_API_URL}/admin/${userData?.clientId}/deletePosition/${p._id}`
                                )
                                .then(() =>
                                  axios
                                    .get(
                                      `${BASE_API_URL}/admin/${userData.clientId}/getPositions`
                                    )
                                    .then((res) =>
                                      setPositionInSector(res.data)
                                    )
                                )
                                .catch((error) => console.error(error));
                            },
                          });
                        }}
                      >
                        {t("Delete")}
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          )}

          {viewModePositions === "table" && (
            <Card className="ws-card" bordered={false}>
              <Table
                columns={positionInSectorColumns}
                dataSource={filteredPositions}
                pagination={false}
                rowKey="_id"
                className="ws-table"
              />
            </Card>
          )}
        </>
      ),
    },
  ];
  console.log("positionInSector", positionInSector);
  return (
    <>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />

      <WorkSectorModal
        isOpen={isModalOpen}
        onCloseModal={() => {
          setWorkSectorData(undefined);
          setModalOpen(false);
        }}
        mode={workSectorData ? "edit" : "create"}
        onUpdate={() => {
          if (params.id !== "new" && userData.clientId) {
            axios
              .get(`${BASE_API_URL}/admin/${userData.clientId}/getWorkSectors`)
              .then((res) => {
                setWorkSectors(res.data);
              })
              .catch((error) => console.error(error));
          }
        }}
        workSectorData={workSectorData}
        locations={locations}
        clientId={userData?.clientId}
      />
      <PositionInSector
        isOpen={isPositionInSectorModalOpen}
        onCloseModal={() => {
          setPositionInSectorModalOpen(false);
          setPositionInSectorData(undefined);
        }}
        positionInSectorData={positionInSectorData}
        mode={positionInSectorData ? "edit" : "create"}
        onUpdate={() => {
          if (params.id !== "new" && userData.clientId) {
            axios
              .get(`${BASE_API_URL}/admin/${userData.clientId}/getPositions`)
              .then((res) => {
                setPositionInSector(res.data);
              })
              .catch((error) => console.error(error));
          }
        }}
        locations={locations}
        clientId={userData?.clientId}
        workSectors={workSectors}
      />
    </>
  );
};
export default WorkSectors;
